import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoquateService {
  baseUrl:string = environment.loquateUrl;
  key:string = environment.loquateKey;
  constructor(private http: HttpClient) { }
   
  getAddressessForPostcode(postCode: any):Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/Capture/Interactive/Find/v1.1/json3.ws?Key=${this.key}&Text=${postCode}&IsMiddleware=True&Container=GB|RM|ENG|3DA-WR5&Origin=52.182,-2.222&Countries=GB&Limit=100&Language=&Bias=&Filters=&GeoFence=`);
  }

  // Adds an address picked with "Find address" to our own address book
  // (backend table `postcodes`). Relative URL, so it goes to our API.
  saveAddress(a: { address1: string; address2?: string; city?: string; county?: string; postalcode: string }) {
    return this.http.post('/address/save', a);
  }

  getAddressDetails(addressID: string) {
    return this.http.get<any>(`${this.baseUrl}/Capture/Interactive/Retrieve/v1.20/json6.ws?Key=${this.key}&Id=${addressID}`);
  }
}
